"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsManagerAssistantVisible = void 0;
const react_router_1 = require("react-router");
const const_1 = require("@app/const");
const store_1 = require("@app/store");
const util_1 = require("@app/util");
// Pages where the manager assistant column must NOT render, matched as path substrings
// (DS PRO prefixes app routes with /organization, so exact matching isn't reliable).
//
//   /my-timetable  — the EMPLOYEE assistant lives there, for everyone including managers
//                    (app/component/pages/my-calendar-2/employee-assistant-card.tsx)
//   /organization  — DS PRO, the org-level interface; the agent is workspace-scoped
//   /paywall       — reachable while authenticated; nothing to assist with until it's paid
//   /no-workspace  — no workspace means the agent has no scope to act in
//   /t/            — terminal/kiosk interface (same carve-out as Websockets)
//   /registration  — the rest of the auth flow is excluded by the auth check below, but
//                    /registration/complete is reached WITH a session: decideRedirect()
//                    parks an authenticated account that has no password yet there, so it
//                    passes every check and the column would open over the form
//
// The remaining unauthenticated pages (/login, /reset-password, /accept-invite, /auth)
// are already excluded by the auth + workspace + permission checks below.
const EXCLUDED_PATHS = [
    '/my-timetable',
    '/organization',
    '/paywall',
    '/no-workspace',
    '/t/',
    '/registration',
];
// Single source of truth for whether the manager assistant column is on screen. Used both
// by Routes (to render the column) and by the app shell (to reserve the right gutter so
// page content isn't covered) — they must never disagree.
const useIsManagerAssistantVisible = () => {
    const location = (0, react_router_1.useLocation)();
    const auth = (0, store_1.useRootSelector)((state) => state.auth);
    const workspaceId = (0, store_1.useRootSelector)((state) => state.workspaceId);
    const { canWrite } = (0, util_1.useAccessRole)();
    if (!(0, util_1.isValue)(auth) || !(0, util_1.isValue)(workspaceId))
        return false;
    // Manager-level only. Same signal the routing config uses to decide someone is a manager
    // (it hides /my-timetable from their nav on exactly this check).
    if (!canWrite(const_1.PERMISSIONS.MNG_CALENDAR))
        return false;
    return !EXCLUDED_PATHS.some((path) => location.pathname.includes(path));
};
exports.useIsManagerAssistantVisible = useIsManagerAssistantVisible;
exports.default = exports.useIsManagerAssistantVisible;
